import React from 'react';
import {useTranslation} from 'react-i18next';
import SubscriptionSelectionCell from '../../../components/SubscriptionSelectionCell';
import {EmailConfirmationPrice} from '../../../projects/emailConfirmation-0424/prices';
import {ProductCode} from '../../../projects/emailConfirmation-0424/products';
import '../../../projects/emailConfirmation-0424/components/TrialSelectionCells.css';
import './GraduationPlanCells.css';

type GraduationPlanCellsProps = {
  onSelect: (code: ProductCode) => void;
  selection: ProductCode;
  products: EmailConfirmationPrice[]; // [weekOption, monthOption]
  isStudent?: boolean;
  bigHeader: string;
  smallHeader: string;
  relabelCards?: boolean;
};

// Control relabels the two plan cards per the copy deck ("Try free · 7-Day Trial",
// "$0.99 · 30-Day Trial"). We keep each product's price `title` on the month card so
// the student strike-through price is preserved, and only swap the subtitle wording;
// the free-week card's title becomes "Try free".
function relabel(product: EmailConfirmationPrice): {title: EmailConfirmationPrice['title']; subtitle: string} {
  const isWeek = product.daysFree === 7;
  return {
    title: isWeek ? 'Try free' : product.title,
    subtitle: isWeek ? '7-Day Trial' : '30-Day Trial',
  };
}

// Local fork of TrialSelectionCells for the graduation experiment. Differs from the
// shared component in two ways the copy deck requires: the "TRY RISE FOR" title is
// replaced by an arm-specific big/small header, and (control) the plan-card labels
// are relabeled. The shared component is intentionally left untouched.
function GraduationPlanCells({
  onSelect,
  selection,
  products,
  isStudent = false,
  bigHeader,
  smallHeader,
  relabelCards = false,
}: GraduationPlanCellsProps) {
  const {t} = useTranslation();
  return (
    <div>
      <div className="parent graduation-plan-header">
        <div className="graduation-plan-header-text">
          <div className="graduation-plan-big-header">{bigHeader}</div>
          <div className="graduation-plan-small-header">{smallHeader}</div>
        </div>
        {isStudent ? <div className="student">{t('checkout_screen.students_save_pct', {pct: '40'})}</div> : null}
      </div>
      {products.map(product => {
        const labels = relabelCards ? relabel(product) : {title: product.title, subtitle: product.subtitle};
        return (
          <SubscriptionSelectionCell
            key={product.productCode}
            title={labels.title}
            subtitle={labels.subtitle}
            onPress={() => onSelect(product.productCode)}
            selected={selection === product.productCode}
          />
        );
      })}
    </div>
  );
}

export default GraduationPlanCells;
